import { gql } from 'apollo-angular';
import { TimeEntryCategory } from '../../entities/timeEntryCategory/timeEntryCategory';

export const UPDATE_TIME_ENTRY_CATEGORY_MUTATION = gql`
mutation updateTimeEntryCategory($timeEntryCategoryInput: TimeEntryCategoryInput) {
  updateTimeEntryCategory(timeEntryCategoryInput: $timeEntryCategoryInput) {
    id
  }
}
`;

export const CREATE_TIME_ENTRY_CATEGORY_MUTATION = gql`
mutation createTimeEntryCategory($timeEntryCategoryInput: TimeEntryCategoryInput) {
  createTimeEntryCategory(timeEntryCategoryInput: $timeEntryCategoryInput) {
    id
  }
}
`;

export const GET_TIME_ENTRY_CATEGORIES_QUERY = gql`
query getTimeEntryCategories{
  getTimeEntryCategories(filter:{
    enabled: true
  }){
    id
    name
  }
}
`;

export interface GetTimeEntryCategoriesResponse {
  getTimeEntryCategories: TimeEntryCategory[];
  loading: boolean;
}
